

































import { ProjectTaskDefault } from "@/api/project-api";
import { ProjectTaskData } from "@/api/project/project-task-type-api";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import TaskModal from "@/components/task/TaskModal.vue";
import _ from "lodash";
import ProjectManagerApi from "@/api/gateways/project-manager-api";
import ProjectWorkerApi from "@/api/gateways/project-worker-api";
import ProjectWorker from "@/entities/project-worker";
import ProjectManager from "@/entities/project-manager";

interface UserOption {
  id: string | number;
  name: string;
}

@Component({
  model: { prop: "defaultValues" },
  components: {
    TaskModal
  }
})
export default class ProjectPropertiesForm extends Vue {
  @Prop({ required: true }) defaultValues!: ProjectTaskDefault[];

  values: ProjectTaskDefault[] = [];
  taskOpen: boolean = false;
  users = [] as UserOption[];
  projectTaskDefault = {} as ProjectTaskDefault;
  dateDefault: string | undefined = "";
  timeDefault: string | undefined = "";
  initTask: ProjectTaskDefault = {} as ProjectTaskDefault;
  date: string | undefined = "";

  handleOpenModalTask(task: ProjectTaskDefault) {
    if (task.task) {
      task.task.canEditName = true;
    }
    this.taskOpen = true;
    const taskDefaults = this.$store.state.taskDefaults;
    const initTask =
      taskDefaults &&
      taskDefaults.find(
        (item: ProjectTaskDefault) => item.key.id == task.key.id
      );
    if (initTask && initTask.task && initTask.task) {
      this.initTask = _.clone(initTask.task);
    }
    this.dateDefault =
      task.task &&
      initTask &&
      initTask.task &&
      (initTask.task as ProjectTaskData).date
        ? (initTask.task as ProjectTaskData).date
        : this.date;
    this.timeDefault =
      task.task && initTask && initTask.task
        ? (initTask.task as ProjectTaskData).time
        : "";
    this.projectTaskDefault = task;
  }

  handleSetDate(task: ProjectTaskDefault, value: string) {
    const updatedTask = Object.assign({}, task);
    updatedTask.value = value;
    if (updatedTask.task) {
      updatedTask.task.date = value;
    }
    this.projectTaskDefault = updatedTask;
    let index = null;
    this.values.forEach((item: ProjectTaskDefault, i) => {
      if (item.key.id == task.key.id) {
        index = i;
      }
    });

    if (index != null) {
      this.values[index] = Object.assign({}, updatedTask);
    }
  }

  get availableValues(): ProjectTaskDefault[] {
    const isCreate = this.$route.name == "project-new";
    this.values.forEach(item => {
      if (!item.task) {
        item.value = isCreate
          ? moment()
              .add(item.value, "days")
              .format("YYYY-MM-DD")
          : item.value != "0000-00-00"
          ? item.value
          : "";
      }
    });

    if (this.values.length) {
      this.date = isCreate
        ? this.values[0].value
        : moment(this.$store.state.project.created, "YYYY-MM-DD", true)
            .clone()
            .add(this.values[0].key.value, "days")
            .format("YYYY-MM-DD");
    }

    return this.values;
  }

  @Watch("defaultValues", { immediate: true })
  onDefaultValuesChanged(defaultValues: ProjectTaskDefault[]) {
    this.values = defaultValues;
  }

  handleSetTask(data: ProjectTaskData) {
    this.projectTaskDefault.task = data;
    const object = this.values.find(
      item =>
        this.projectTaskDefault.key &&
        item.key.id == this.projectTaskDefault.key.id
    );
    if (object) {
      object.task = data;
      this.values.forEach(item => (item.value = data.date));
    }
    this.taskOpen = false;
  }

  async mounted() {
    const user = this.$store.state.user;
    this.users = [
      {
        id: user.staffId,
        name: user.name
      }
    ];
    if (this.$route.name == "project-new") {
      return;
    }

    this.users = [];
    const pm = new ProjectManagerApi(
      this.$store.getters.api,
      Number(this.$route.params.projectId)
    );
    const pw = new ProjectWorkerApi(
      this.$store.getters.api,
      Number(this.$route.params.projectId)
    );
    const resPm = await pm.assigned();
    resPm.forEach((item: ProjectManager) => {
      if (!item.isHiddenInfo) {
        this.users.push({
          id: item.id,
          name: item.name
        });
      }
    });

    const resPw = await pw.assigned();
    resPw.forEach((item: ProjectWorker) => {
      if (!item.isHiddenInfo) {
        this.users.push({
          id: item.id,
          name: item.name
        });
      }
    });

    const clientStaff = this.$store.state.project.clientStaff;
    if (clientStaff && clientStaff != "0" && Object.keys(clientStaff).length) {
      if (!clientStaff.isHiddenInfo) {
        this.users.push({
          id: clientStaff.id,
          name: clientStaff.name
        });
      }
    }

    if (this.users.some(item => item.id == user.staffId)) {
      this.users = this.users.filter(item => item.id != user.staffId);
      this.users.unshift({
        id: user.staffId,
        name: user.name
      });
    }
  }
}
